function CloseButton({ onClick }) {
	return (
		<button className="close-button" onClick={onClick}>
			&times;
		</button>
	);
}

export default CloseButton;
